/**
 * 
// 描边连接类型
export type StrokeLinejoin = 'miter' | 'round' | 'bevel';

// 描边端点类型
export type StrokeLinecap = 'butt' | 'round' | 'square';

// 主题
export type Theme = 'outline' | 'filled' | 'two-tone' | 'multi-color';
 * 
 */

const base = {
    size: 16,
    strokeWidth: 4,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
}

function initColors(
    theme, 
    customColor = ['#000000', '#000000', '#000000', '#000000'], 
    isCurrentColor) {
    const colors = Array(2).fill(customColor[0]);
    // 以下为留白逻辑
    // 线性
    if (theme === 'outline') {
        colors[0] = isCurrentColor ? 'currentColor' : customColor[0];
        colors[1] = '#ffffff';
        colors[2] = isCurrentColor ? 'currentColor' : customColor[0];
    }
    // 面性
    if (theme === 'filled') {
        colors[0] = isCurrentColor ? 'currentColor' : customColor[1];
        colors[1] = isCurrentColor ? 'currentColor' : customColor[1];
        colors[2] = '#ffffff';
    }
    // 双色
    if (theme === 'two-tone') {
        colors[0] = customColor[0];
        colors[1] = customColor[1];
        colors[2] = customColor[0];
    }
    // 多色
    if (theme === 'multi-color') {
        colors[0] = customColor[0];
        colors[1] = customColor[1];
        colors[2] = customColor[2];
    }
    return colors;
}

function initSize(size, isFontSize) {
    return isFontSize ? '1em' : `${size}px`;
}

export default {
    name: 'commonIconAdd1',
    cName: '新增1',
    render(config = {
        theme: 'outline', // 必传
    }) {
        const props = {
            ...base,
            ...config,
            size: initSize(config.size, config.isFontSize),
            colors: initColors(config.theme, config.colors, config.isCurrentColor)
        }
        return this.svgFn(props);
    },
    svgFn: (props) => (
        `
        <svg width="${props.size}" height="${props.size}" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" fill="none" fill-rule="evenodd">
                <g transform="translate(4.000000, 4.000000)" stroke-width="${props.strokeWidth}">
                    <circle stroke="${props.colors[0]}" fill="${props.colors[1]}" stroke-width="${props.strokeWidth}" cx="20" cy="20" r="20"></circle>
                    <line x1="20" y1="11" x2="20" y2="29" stroke="${props.colors[2]}" stroke-linecap="${props.strokeLinecap}"></line>
                    <line x1="29" y1="20" x2="11" y2="20" stroke="${props.colors[2]}" stroke-linecap="${props.strokeLinecap}"></line>
                </g>
            </g>
        </svg>
        `
    )
};
